module.exports = __webpack_public_path__ + "static/img/20.8458fb7d.png";